<div class="i-page-top">
  <div class="container">
    <!--Menu-->
    <div class="i-menu row align-items-center pt-3 pb-2">
      <div class="navbar-brand col-6 col-sm-8 col-md-6 col-lg-4 mr-auto py-2 px-2 text-center text-sm-left">
        <a href="#" routerLink="/home" aria-label="Private"
          ><img src="assets/img/logo_cinza.svg" class="img-fluid my-auto" alt="Private"
        /></a>
      </div>
      <div class="col-6 col-sm-4 col-md-6 col-lg-8 ml-auto py-2">
        <app-menu></app-menu>
      </div>
    </div>
  </div>
</div>
<div class="i-page-content i-career">
  <!--Call-Text-->
  <div class="i-main-call mt-3 py-5">
    <div class="container py-4 px-0">
      <div class="col-12 text-left px-2 px-lg-5 py-5">FA&Ccedil;A PARTE <br /><br />DA NOSSA EQUIPE</div>
    </div>
  </div>
  <!--About-Content-->
  <div class="i-about container">
    <div class="i-content row pt-5">
      <div class="i-subtitle col-12 col-lg-10 text-left py-5 px-2 pl-lg-5 pr-lg-3">
        NOSSO PROP&Oacute;SITO &Eacute; MOVER AS PESSOAS PARA O SEU MELHOR LUGAR, POR ISSO CONSTRUÍMOS UM TIME COM AS
        MELHORES PESSOAS DO MERCADO.
      </div>
    </div>
    <div class="i-section row py-5 px-2 px-lg-5">
      <div class="i-box i-first col-12 col-lg-6 col-xl-4 d-flex align-items-center justify-content-center px-0">
        <div class="i-mask d-flex flex-column justify-content-center">
          <div class="i-title text-left px-5">
            ATENDA<br />
            CLIENTES<br />
            DE ALTO<br />
            PADRÃO
          </div>
          <div class="px-5 pt-5">
            <a data-toggle="modal" data-target="#modal_01" class="i-btn"> SAIBA MAIS </a>
          </div>
        </div>
      </div>
      <div class="i-box i-second col-12 col-lg-6 col-xl-4 d-flex align-items-center justify-content-center px-0">
        <div class="i-mask d-flex flex-column justify-content-center">
          <div class="i-title text-left px-5">
            <div style="font-size: 90%; line-height: 1.225em">
              TENHA<br />
              PREVISIBILIDADE<br />
              SOBRE<br />
              RESULTADOS<br />FINANCEIROS
            </div>
          </div>
          <div class="px-5 pt-5">
            <a data-toggle="modal" data-target="#modal_02" class="i-btn"> VEJA OS N&Uacute;MEROS </a>
          </div>
        </div>
      </div>
      <div class="i-box i-third col-12 col-lg-6 col-xl-4 d-flex align-items-center justify-content-center px-0">
        <div class="i-mask d-flex flex-column justify-content-center">
          <div class="i-title text-left px-5">
            TRABALHE<br />
            EM UM<br />
            AMBIENTE<br />
            INCR&Iacute;VEL
          </div>
          <div class="px-5 pt-5">
            <a data-toggle="modal" data-target="#modal_03" class="i-btn"> CONHE&Ccedil;A </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--Modal Campaign-->
  <div class="modal fade p-0" id="modal_01" tabindex="-1" role="dialog" aria-labelledby="modal" aria-hidden="true">
    <div class="i-first-modal">
      <div class="modal-dialog mt-0" role="document">
        <div class="modal-content">
          <div class="row px-2 px-lg-5">
            <div class="i-title col-12 text-left px-lg-5">
              ATENDA<br />
              CLIENTES<br />
              DE ALTO<br />
              PADRÃO
            </div>
            <div class="i-subtitle col-12 text-left pt-3 px-lg-5">
              <div class="i-hr"></div>
              A Private se dedica aos melhores bairros de Porto Alegre e São Paulo. Com uma estratégia focada, atraímos
              clientes ideais para nosso portfólio de imóveis. Fazendo parte do nosso time você encontrará o melhor
              lugar para este público.
              <div class="i-hr"></div>
            </div>
            <div class="i-subtitle col-12 text-left pb-5 mb-2 px-lg-5">Opiniões dos clientes:</div>
            <div class="i-testimony col-12 pb-5 pt-4 text-left px-lg-5">
              “ATENDIMENTO PERSONALIZADO, CORRETOR SE COLOCA NO LUGAR DO CLIENTE. TENHO ESTA SENSAÇÃO.”
              <div class="i-witness pt-2">~ EDUARDO, COMPRADOR ~</div>
            </div>
            <div class="i-testimony i-size-02 col-12 pb-5 pt-4 text-left px-lg-5">
              “SENTINDO MUITA CONFIANÇA EM FAZER NEGÓCIOS COM VOCÊS E O QUE PUDE PERCEBER É QUE A IMOBILIÁRIA SEMPRE
              ESTAVA PREOCUPADA EM PRESERVAR A INTEGRIDADE FINANCEIRA DE AMBAS PARTES!”
              <div class="i-witness">~ ANTÔNIO, VENDEDOR ~</div>
            </div>
            <div class="i-testimony i-size-03 col-12 pt-4 text-left px-lg-5">
              “O MAIS IMPORTANTE PRA MIM É QUE NÃO FUI PRESSIONADA, TIVE LIBERDADE PRA DECIDIR. NOTA MIL PARA ELA E PARA
              O RESTANTE DA EQUIPE QUE DEU O SUPORTE.”
              <div class="i-witness">~ CRISTINA, COMPRADORA ~</div>
              <div class="i-vr"></div>
            </div>
            <div class="px-2 px-lg-5">
              <button type="submit" class="i-btn" data-dismiss="modal">VOLTAR</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade p-0" id="modal_02" tabindex="-1" role="dialog" aria-labelledby="modal" aria-hidden="true">
    <div class="i-second-modal">
      <div class="modal-dialog mt-0" role="document">
        <div class="modal-content">
          <div class="row px-2 px-lg-5">
            <div class="i-title col-12 text-left px-lg-5">
              TENHA<br />
              PREVISIBILIDADE<br />
              SOBRE<br />
              RESULTADOS<br />FINANCEIROS
            </div>
            <div class="i-subtitle col-12 text-left py-5 px-lg-5">
              <div class="i-hr"></div>
              Nosso compromisso é elevar o padrão de vida do corretor de imóveis. Para isso, fornecemos subsídios para
              que todos os membros do nosso time tenham um desempenho exepcional, como um time de marketing dedicado,
              suporte jurídico e coaching imobiliário.
            </div>
            <div class="i-testimony col-12 text-left px-lg-5 py-5">
              GERAMOS <span class="i-size-high">MAIS DE 10.000 LEADS</span> E AGENCIAMOS MAIS DE
              <span class="i-size-high">2.500 NOVOS IMÓVEIS DE ALTO PADRÃO</span> ANUALMENTE, CRIANDO INCRÍVEIS
              OPORTUNIDADES DE NEGÓCIOS PARA NOSSOS CLIENTES.
            </div>
            <div class="i-testimony col-12 text-left px-lg-5 pt-5">
              NOSSO TICKET MÉDIO PARA IMÓVEIS VENDIDOS, É
              <span class="i-size-high">TRÊS VEZES MAIOR QUE A MÉDIA DO MERCADO.</span>
              <div class="i-vr"></div>
            </div>
            <div class="px-2 px-lg-5">
              <button type="submit" class="i-btn" data-dismiss="modal">VOLTAR</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade p-0" id="modal_03" tabindex="-1" role="dialog" aria-labelledby="modal" aria-hidden="true">
    <div class="i-third-modal">
      <div class="modal-dialog mt-0" role="document">
        <div class="modal-content">
          <div class="row px-2 px-lg-5">
            <div class="i-title col-12 text-left px-lg-5">
              TRABALHE<br />
              EM UM<br />
              AMBIENTE<br />
              INCR&Iacute;VEL
            </div>
            <div class="i-subtitle col-12 text-left py-3 px-lg-5">
              <div class="i-hr"></div>
              Realizamos pesquisas de satisfação anônimas com nossa equipe, e estamos sempre de olho no feedback de quem
              é mais importante pra nós: você.
            </div>
            <div class="i-testimony col-12 text-left px-lg-5 pt-5">
              NOSSA NOTA É<br />
              <span class="i-size-high">9,6</span>
              <div class="i-hr"></div>
            </div>
            <div class="i-testimony col-12 pb-5 text-left px-lg-5">
              “PERSPECTIVAS, PARCERIA E MATURIDADE PROFISSIONAL. A PRIVATE ESTÁ ELEVANDO-SE CADA DIA MAIS E SE
              POSICIONANDO COMO UMA DAS PRINCIPAIS EMPRESAS NO CENÁRIO NACIONAL.”
            </div>
            <div class="i-testimony col-12 text-left px-lg-5">
              “O QUE FAZ A PRIVATE SER O QUE ELA É, SÃO AS PESSOAS. TEMOS UM TIME INCRÍVEL DE PESSOAS CAPACITADAS E QUE
              VESTEM A CAMISA, ME FAZEM QUEREM VIR TRABALHAR JUNTO DELAS TODOS OS DIAS.”
              <div class="i-vr"></div>
            </div>
            <div class="px-2 px-lg-5">
              <button type="submit" class="i-btn" data-dismiss="modal">VOLTAR</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--Values-->
  <div class="i-values">
    <div class="container">
      <div class="i-section row pt-5">
        <div class="i-title col-12 text-center py-3 px-2 px-lg-5">NOSSOS VALORES</div>
        <div class="i-subtitle-main col-12 text-left pt-5 px-2 px-lg-5">/// COMPROMISSO</div>
        <div class="col-12 col-lg-6 col-xl-4 px-2 px-lg-5 py-2">
          <div class="i-subtitle text-left py-4 pr-5">DISCIPLINA</div>
          <p class="i-text">
            Desenvolvemos um m&eacute;todo que eleva o padr&atilde;o de qualidade de atendimento e engajamos nossos
            colaboradores para segui-lo.
          </p>
          <br />
        </div>
        <div class="col-12 col-lg-6 col-xl-4 px-2 px-lg-5 py-2">
          <div class="i-subtitle text-left py-4 pr-5">RESULTADO</div>
          <p class="i-text">
            Acreditamos que a&ccedil;&otilde;es adequadas d&atilde;o significado ao trabalho e trazem
            realiza&ccedil;&atilde;o.
          </p>
          <br />
        </div>
        <div class="col-12 col-lg-6 col-xl-4 px-2 px-lg-5 py-2">
          <div class="i-subtitle text-left py-4 pr-5">ORGANIZA&Ccedil;&Atilde;O</div>
          <p class="i-text">
            Sincronizamos esfor&ccedil;os e instrumentalizamos processos para alcan&ccedil;ar excel&ecirc;ncia com
            agilidade.
          </p>
          <br />
        </div>
      </div>
      <div class="i-section row">
        <div class="i-subtitle-main col-12 text-left pt-5 px-2 px-lg-5">/// PROTAGONISMO</div>
        <div class="col-12 col-lg-6 col-xl-4 px-2 px-lg-5 py-2">
          <div class="i-subtitle text-left py-4 pr-5">INOVA&Ccedil;&Atilde;O</div>
          <p class="i-text">
            Repensamos as pr&aacute;ticas do mercado propondo processos mais eficientes com foco no sucesso do cliente.
          </p>
          <br />
        </div>
        <div class="col-12 col-lg-6 col-xl-4 px-2 px-lg-5 py-2">
          <div class="i-subtitle text-left py-4 pr-5">MELHORIA CONT&Iacute;NUA</div>
          <p class="i-text">
            Fomentamos a especializa&ccedil;&atilde;o das pessoas para estimular a evolu&ccedil;&atilde;o constante do
            neg&oacute;cio.
          </p>
          <br />
        </div>
        <div class="col-12 col-lg-6 col-xl-4 px-2 px-lg-5 py-2">
          <div class="i-subtitle text-left py-4 pr-5">ESP&Iacute;RITO EMPREENDEDOR</div>
          <p class="i-text">
            Estimulamos nas pessoas a autorresponsabilidade e a criatividade como caminho para a
            concretiza&ccedil;&atilde;o dos objetivos.
          </p>
          <br />
        </div>
      </div>
      <div class="i-section row pb-5">
        <div class="i-subtitle-main col-12 text-left pt-5 px-2 px-lg-5">/// RELACIONAMENTO</div>
        <div class="col-12 col-lg-6 col-xl-4 px-2 px-lg-5 py-2">
          <div class="i-subtitle text-left py-4 pr-5">ELEG&Acirc;NCIA</div>
          <p class="i-text">
            Entendemos o tempo de cada rela&ccedil;&atilde;o e atuamos de forma distinta, conduzindo conversas com
            simplicidade, confidencialidade e transpar&ecirc;ncia.
          </p>
          <br />
        </div>
        <div class="col-12 col-lg-6 col-xl-4 px-2 px-lg-5 py-2">
          <div class="i-subtitle text-left py-4 pr-5">RECIPROCIDADE</div>
          <p class="i-text">
            Agimos com empatia, promovendo atitudes pautadas na confian&ccedil;a e na coopera&ccedil;&atilde;o.
          </p>
          <br />
        </div>
        <div class="col-12 col-lg-6 col-xl-4 px-2 px-lg-5 py-2">
          <div class="i-subtitle text-left py-4 pr-5">RESPEITO</div>
          <p class="i-text">
            Constitu&iacute;mos ambientes onde ideias se manifestam de maneira mutua com equil&iacute;brio e
            valoriza&ccedil;&atilde;o das rela&ccedil;&otilde;es humanas.
          </p>
          <br />
        </div>
      </div>
    </div>
  </div>
  <!--Pictures-->
  <div class="container"></div>
  <div class="i-contact container py-5">
    <div class="row py-4 mt-5">
      <div class="col-12 text-center">
        <h1 class="i-title">TRABALHE CONOSCO</h1>
      </div>
    </div>
    <div class="i-content row">
      <div class="i-subtitle col-12 text-center py-5 pl-lg-5 pr-lg-3">
        PREENCHA O FORMUL&Aacute;RIO ABAIXO PARA CADASTRAR SEU CURR&Iacute;CULO EM NOSSO BANCO DE TALENTOS E SER AVISADO
        SOBRE A ABERTURA DE NOVAS OPORTUNIDADES NA PRIVATE.
      </div>
    </div>
    <form (ngSubmit)="onSend()" [formGroup]="fmGroup" #formDir="ngForm">
      <div class="form-row px-2 px-lg-5">
        <mat-form-field class="col-12 col-lg-8 mx-auto mb-3 i-text" appearance="fill">
          <mat-label class="i-text">NOME</mat-label>
          <input matInput type="text" class="i-text pb-1" maxlength="255" formControlName="name" />
          <mat-error class="i-text-sm mt-1" *ngIf="fmGroup.get('name').errors?.required">
            CAMPO OBRIGAT&Oacute;RIO
          </mat-error>
        </mat-form-field>

        <mat-form-field class="col-12 col-lg-8 mx-auto mb-3 mt-1" appearance="fill">
          <mat-label class="i-text">TELEFONE</mat-label>
          <input
            matInput
            type="text"
            class="i-text pb-2"
            placeholder="(00) 0000-00000"
            mask="(00) 0000-0000||(00) 00000-0000"
            maxlength="16"
            formControlName="phone" />
          <mat-error
            class="i-text-sm mt-1"
            *ngIf="fmGroup.get('phone').errors?.minlength && !fmGroup.get('phone').errors?.required">
            POR FAVOR, INFORME O TELEFONE CORRETAMENTE
          </mat-error>
          <mat-error class="i-text-sm mt-1" *ngIf="fmGroup.get('phone').errors?.phoneSintaxError">
            POR FAVOR, VERIFIQUE O NÚMERO DIGITADO
          </mat-error>
          <mat-error class="i-text-sm mt-1" *ngIf="fmGroup.get('phone').errors?.required">
            CAMPO OBRIGAT&Oacute;RIO
          </mat-error>
        </mat-form-field>

        <mat-form-field class="col-12 col-lg-8 mx-auto mb-3 mt-1" appearance="fill">
          <mat-label class="i-text">E-MAIL</mat-label>
          <input matInput type="text" class="i-text pb-2" maxlength="255" formControlName="email" />

          <mat-error
            class="i-text-sm mt-1"
            *ngIf="fmGroup.get('email').errors?.email && !fmGroup.get('email').errors?.required">
            POR FAVOR, INFORME UM E-MAIL VÁLIDO
          </mat-error>
          <mat-error class="i-text-sm mt-1" *ngIf="fmGroup.get('email').errors?.required">
            CAMPO OBRIGAT&Oacute;RIO
          </mat-error>
        </mat-form-field>

        <mat-form-field class="col-12 col-lg-8 mx-auto mb-3 mt-1" appearance="fill">
          <mat-label class="i-text">UF</mat-label>
          <mat-select name="uf" placeholder="UF" class="i-text" role="combobox" formControlName="uf">
            <mat-option value="RS">Rio Grande do Sul</mat-option>
            <mat-option value="SP">São Paulo</mat-option>
            <mat-option></mat-option>
            <mat-option *ngFor="let uf of ufs" [value]="uf.sigla">{{ uf?.nome }}</mat-option>
          </mat-select>
          <mat-error class="i-text-sm mt-1" *ngIf="fmGroup.get('uf').errors?.required">
            CAMPO OBRIGAT&Oacute;RIO
          </mat-error>
        </mat-form-field>

        <mat-form-field class="col-12 col-lg-8 mx-auto mb-3 mt-1" appearance="fill">
          <mat-label class="i-text">INSTAGRAM</mat-label>
          <input matInput type="text" class="i-text pb-2" maxlength="255" formControlName="instagram" />
          <mat-error class="i-text-sm mt-1" *ngIf="fmGroup.get('instagram').errors?.required">
            CAMPO OBRIGAT&Oacute;RIO
          </mat-error>
        </mat-form-field>

        <mat-form-field class="col-12 col-lg-8 mx-auto mb-3 mt-1" appearance="fill">
          <!-- <span matPrefix>http://linkedin.com/in/&nbsp;</span> -->
          <mat-label class="i-text">LINKEDIN</mat-label>
          <input matInput type="text" class="i-text pb-2" maxlength="255" formControlName="linkedin" />
          <mat-error class="i-text-sm mt-1" *ngIf="fmGroup.get('linkedin').errors?.required">
            CAMPO OBRIGAT&Oacute;RIO
          </mat-error>
        </mat-form-field>
      </div>
      <!--Button-->
      <div class="my-3 text-center"><button type="submit" class="i-btn">ENVIAR</button></div>
    </form>
  </div>
</div>
